module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e8092ac373526cf01910e8be1c42b0d5.png";